import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f2063c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "FAQ - liste", -1))
const _hoisted_4 = { class: "filter-wrapper" }
const _hoisted_5 = { class: "filter" }
const _hoisted_6 = { class: "label-sm search-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-sm" }, "Kategori", -1))
const _hoisted_8 = { class: "py-3 faq-form-actions" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "no-faqs"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "pagination pagination-top" }
const _hoisted_13 = { class: "faqs" }
const _hoisted_14 = { class: "pagination pagination-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_levels_select = _resolveComponent("levels-select")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_FAQList = _resolveComponent("FAQList")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "faq-site" }, {
      default: _withCtx(() => [
        _createVNode(_component_Messages, { class: "faq-index-messages" }),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_HcButton, {
            color: "green",
            type: "inertia-link",
            href: _ctx.route('faq.create')
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ny FAQ ")
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode(" Søk "),
              _withDirectives(_createElementVNode("input", {
                class: "form-input",
                type: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.search) = $event)),
                id: "search"
              }, null, 512), [
                [_vModelText, _ctx.form.search]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createVNode(_component_levels_select, {
                options: _ctx.options,
                limit: 1000,
                modelValue: _ctx.selectedOptionId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOptionId) = $event)),
                placeholder: "Søk etter kategori",
                open: false
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Checkbox, {
                label: "Mine utkast",
                modelValue: _ctx.form.is_draft,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_draft) = $event)),
                errorMessage: ''
              }, null, 8, ["modelValue"]),
              _hoisted_9
            ])
          ])
        ]),
        (_ctx.faqs.total == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Ingen FAQer "))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Pagination, {
                  size: _ctx.paginationSize,
                  paginate: _ctx.faqs
                }, null, 8, ["size", "paginate"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_FAQList, {
                  class: "faq-list-mobile",
                  faqs: _ctx.faqs.data
                }, null, 8, ["faqs"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Pagination, {
                  size: _ctx.paginationSize,
                  paginate: _ctx.faqs
                }, null, 8, ["size", "paginate"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}